import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import ReactQuill from "react-quill";
import api from "../../../api";
import Logo from "../../../images/logo-2.png";
import add from "../../../images/add.png";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";

export function AddLiveSession({ getVideo, setShow }) {
  const adminStore = useSelector((state) => state.adminReducer);

  const [loader, setLoader] = useState(false);

  const [inputData, setInputData] = useState({
    video: "",
    category: "",
  });

  const handleSubmit = async () => {
    try {
      if (!inputData?.link) {
        setLoader(false);
        alert("Please insert iframe");
        return;
      }
      if (!inputData?.eventTime) {
        setLoader(false);
        alert("Please select event time");
        return;
      }
      setLoader(true);
      const formData = {
        link: inputData?.link,
        title: inputData?.title || "",
        eventTime: inputData?.eventTime,
      };

      // console.log(formData);

      const signalResponse = await api.liveSessionAdd(formData);
      if (signalResponse?.success) {
        alert("Form submited");
        setInputData({
          title: "",
          link: "",
          eventTime: "",
        });

        setLoader(false);
        setShow(false);
        getVideo();
      } else {
        setLoader(false);
        alert("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong");
    }
  };

  /**
   * Convert "YYYY-MM-DDTHH:mm" or "YYYY-MM-DDTHH:mm:ss" (datetime-local value)
   * into an ISO UTC string representing the same local clock moment.
   *
   * Example:
   *  localValue = "2025-11-13T20:40"  (admin in GMT+5)
   *  returns "2025-11-13T15:40:00.000Z"
   */
  function localDatetimeToUTC(localValue) {
    if (!localValue) return null;

    const [datePart, timePart] = localValue.split("T");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute] = timePart.split(":").map(Number);

    // Create a Date object in local timezone (Pakistan time in your case)
    const localDate = new Date(year, month - 1, day, hour, minute);

    // Convert to UTC ISO string
    return localDate.toISOString();
  }

  const handleChange = (e) => {
    if (e.target.name === "eventTime") {
      // Convert local datetime to UTC ISO string
      const utcIso = localDatetimeToUTC(e.target.value);
      console.log(utcIso);

      setInputData({ ...inputData, [e.target.name]: utcIso });
    } else {
      setInputData({ ...inputData, [e.target.name]: e.target.value });
    }
  };

  return (
    <>
      <div className="row mx-0 drivers-row">
        <div className="col-xl-6 col-md-7  d-flex justify-content-between pr-0">
          <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
            Add Live Session
          </h4>
        </div>
      </div>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="descMainPost">
            <div className="form-group mb-3">
              <input
                type="text"
                name="title"
                className="form-control"
                onChange={handleChange}
                placeholder="Add Title"
              />
            </div>
            <div className="form-group mb-3">
              <input
                type="datetime-local"
                name="eventTime"
                className="form-control"
                onChange={handleChange}
                placeholder="Event Time"
              />
            </div>

            <div className="form-group mb-3">
              <textarea
                name="link"
                className="form-control"
                onChange={handleChange}
                placeholder="Add Link Iframe"
              ></textarea>
            </div>
          </div>

          <div className="sendMailBtn mt-3">
            <button onClick={handleSubmit} className="btn-dark">
              Submit
            </button>
          </div>
        </div>
      </div>

      {loader && (
        <div className="seekoLoader">
          <div className="loader">
            <img src={Logo} alt="loader" />
          </div>
        </div>
      )}
    </>
  );
}
